export const GLOBAL = window;
